import { RoleLevel, TopicTypeId } from '@app/origami-api/constants';

export namespace Icons {
  export enum ByFileType {
    image = 'file-image fa-regular',
    pdf = 'file-pdf fa-regular',
    word = 'file-word fa-regular',
    powerpoint = 'file-powerpoint fa-regular',
    excel = 'file-excel fa-regular',
    audio = 'file-audio fa-regular',
    video = 'file-video fa-regular',
    zip = 'file-zipper fa-regular',
    code = 'file-code fa-regular',
    file = 'file fa-regular',
    text = 'file-lines fa-regular',
    folder = 'folder-open fa-regular',
    link = 'link fa-solid',
    other = 'paperclip fa-solid',
    empty = 'ban fa-solid',
    list = 'list-ul fa-solid',
  }

  export function getColorByFileType(fileName: string, fullMatch: boolean = true) {
    const fileExt = (fullMatch ? fileName : getFileType(fileName)) || '';
    switch (fileExt.toLowerCase()) {
      /*
      case 'gif':
      case 'jpeg':
      case 'jpg':
      case 'png':
        return '#B8E986';
      */
      case 'pdf':
        return '#F27364';
      case 'doc':
      case 'docx':
        return '#6BADD9';
      case 'ppt':
      case 'pptx':
        return '#B8670D';
      case 'xls':
      case 'xlsx':
      case 'csv':
        return '#74A960';
      /*
      case 'aac':
      case 'mp3':
      case 'ogg':
        return '#4C8FBC';
      case 'avi':
      case 'flv':
      case 'mkv':
      case 'mp4':
        return '#FF7889';
      case 'gz':
      case 'zip':
        return '#BEEB8F';
      */
      case 'txt':
        return '#4C8FBC';
      /*
      case 'file':
        return '#4C8FBC';
      case 'dir':
        return '#000000';
      */
      default:
        return 'var(--text-brand-saturated)';
    }
  }

  export function getColorByTopicType(topicTypeId: number) {
    switch (topicTypeId) {
      case TopicTypeId.DocumentPlaceholder:
      case TopicTypeId.MissingDocument:
        return '#A2C4E2';
      case TopicTypeId.DeletedPlaceholder:
        return '#FF001F';
      default:
        return null;
    }
  }

  export function getClassByFileType(fileName: string, fullMatch: boolean = true): Icons.ByFileType {
    if (fileName == null) {
      return <any>'';
    }

    const fileExt = fullMatch ? fileName : getFileType(fileName);

    switch (fileExt.toLowerCase()) {
      case 'gif':
      case 'jpeg':
      case 'jpg':
      case 'png':
      case 'tif':
        return Icons.ByFileType.image;
      case 'pdf':
        return Icons.ByFileType.pdf;
      case 'doc':
      case 'docx':
        return Icons.ByFileType.word;
      case 'ppt':
      case 'pptx':
        return Icons.ByFileType.powerpoint;
      case 'xls':
      case 'xlsx':
      case 'csv':
        return Icons.ByFileType.excel;
      case 'aac':
      case 'mp3':
      case 'ogg':
        return Icons.ByFileType.audio;
      case 'avi':
      case 'flv':
      case 'mkv':
      case 'mp4':
      case 'wmv':
      case 'webm':
      case 'm2ts':
        return Icons.ByFileType.video;
      case 'gz':
      case 'zip':
        return Icons.ByFileType.zip;
      case 'css':
      case 'html':
      case 'js':
        return Icons.ByFileType.code;
      case 'file':
        return Icons.ByFileType.file;
      case 'txt':
        return Icons.ByFileType.text;
      case 'dir':
        return Icons.ByFileType.folder;
      default:
        return Icons.ByFileType.other;
    }
  }

  export function getClassByTopicType(topicTypeId: number) {
    switch (topicTypeId) {
      case TopicTypeId.DocumentPlaceholder:
      case TopicTypeId.MissingDocument:
        return 'file fa-regular';
      case TopicTypeId.DeletedPlaceholder:
        return 'xmark fa-solid';
      default:
        return null;
    }
  }

  export function getUserRoleIconColor(
    role: 'SUPERADMIN' | 'ADMIN' | 'MANAGER' | 'EDITOR' | 'READER' | 'NO_ACCESS' | RoleLevel | number,
  ) {
    if (role === 'SUPERADMIN' || Number(role) >= RoleLevel.SUPERADMIN) {
      // return '#FFBF55';
      return '#FFB700';
    }
    if (role === 'ADMIN' || (Number(role) >= RoleLevel.ADMIN && Number(role) < RoleLevel.SUPERADMIN)) {
      // return '#FF7889';
      return '#FF7889';
    }
    if (role === 'MANAGER' || (Number(role) >= RoleLevel.MANAGER && Number(role) < RoleLevel.ADMIN)) {
      return '#e887e8';
    }
    if (role === 'EDITOR' || (Number(role) >= RoleLevel.EDITOR && Number(role) < RoleLevel.MANAGER)) {
      // return '#B8E986';
      return '#B8E986';
    }
    if (role === 'READER' || (Number(role) >= RoleLevel.READER && Number(role) < RoleLevel.EDITOR)) {
      // return '#68AEFF';
      return '#6AAEDC';
    }
    if (role === 'NO_ACCESS' || (Number(role) >= RoleLevel.NO_ACCESS && Number(role) <= RoleLevel.READER)) {
      // return '#E6E6E6';
      return '#ADADAD';
    }
    if (role === null) {
      return '#666';
    }
    return '#ADADAD';
  }

  export function getUserRoleIconClass(
    role: 'SUPERADMIN' | 'ADMIN' | 'MANAGER' | 'EDITOR' | 'READER' | 'NO_ACCESS' | RoleLevel | number,
  ) {
    if (role === 'SUPERADMIN' || Number(role) >= RoleLevel.SUPERADMIN) {
      return 'icon-user-super-admin';
    }
    if (role === 'ADMIN' || (Number(role) >= RoleLevel.ADMIN && Number(role) < RoleLevel.SUPERADMIN)) {
      return 'icon-user-admin';
    }
    if (role === 'MANAGER' || (Number(role) >= RoleLevel.MANAGER && Number(role) < RoleLevel.ADMIN)) {
      return 'icon-user-manager';
    }
    if (role === 'EDITOR' || (Number(role) >= RoleLevel.EDITOR && Number(role) < RoleLevel.MANAGER)) {
      return 'icon-user-editor';
    }
    if (role === 'READER' || (Number(role) >= RoleLevel.READER && Number(role) < RoleLevel.EDITOR)) {
      return 'icon-user-reader';
    }
    if (role === 'NO_ACCESS' || (Number(role) >= RoleLevel.NO_ACCESS && Number(role) <= RoleLevel.READER)) {
      return 'icon-user-no-access';
    }
    if (role === null) {
      return 'icon-contact';
    }
    return 'icon-user-no-access';
  }

  export function getUserRoleName(
    role: 'SUPERADMIN' | 'ADMIN' | 'MANAGER' | 'EDITOR' | 'READER' | 'NO_ACCESS' | RoleLevel | number,
  ) {
    const strings = tiStrings.shared.icons;
    if (role === 'SUPERADMIN' || Number(role) >= RoleLevel.SUPERADMIN) {
      return strings.superAdmin;
    }
    if (role === 'ADMIN' || (Number(role) >= RoleLevel.ADMIN && Number(role) < RoleLevel.SUPERADMIN)) {
      return strings.admin;
    }
    if (role === 'MANAGER' || (Number(role) >= RoleLevel.MANAGER && Number(role) < RoleLevel.ADMIN)) {
      return strings.manager;
    }
    if (role === 'EDITOR' || (Number(role) >= RoleLevel.EDITOR && Number(role) < RoleLevel.MANAGER)) {
      return strings.editor;
    }
    if (role === 'READER' || (Number(role) >= RoleLevel.READER && Number(role) < RoleLevel.EDITOR)) {
      return strings.reader;
    }
    if (role === 'NO_ACCESS' || (Number(role) >= RoleLevel.NO_ACCESS && Number(role) <= RoleLevel.READER)) {
      return strings.noAccess;
    }
    return strings.noAccess;
  }

  export function getFileType(fileName) {
    const extension = (fileName || '').match(/\.[^.]*$/g);
    return extension && extension[0] ? extension[0].slice(1).toLowerCase() : '';
  }

  export function getDefaultMembersIconClass(member: 'user' | 'users' | 'group' | 'everyone') {
    switch (member) {
      case 'user':
        return 'icon-user-default';
      case 'users':
        return 'icon-users-default';
      case 'group':
        return 'icon-group';
      case 'everyone':
        return 'icon-everyone';
    }
  }
}
